import React from 'react';
import Aux from '../../../hoc/_Aux';


const Image = (props) => (
    <Aux>
        <img id={props.id} className={props.isResponsive ? props.imgName + " img-resp" : props.imgName} src={props.imgPath} alt={props.imgName} onClick={props.action}/>
    </Aux>
);

export default Image;


// WEBPACK FOOTER //
// ./src/containers/UI/Image/Image.js